import axios from '@/axios/index'

// 核心指标接口
export function getMassCore(data) {
  return axios({
    url: '/api/banner/mass/core/statistics',
    method: 'post',
    data
  })
}

// 声量趋势接口
export function getVoiceTrend(data) {
  return axios({
    url: '/api/banner/mass/index/trend',
    method: 'post',
    data
  })
}

// 排序指标
export function getSortLabel() {
  return axios({
    url: '/api/label/line/index/label',
    method: 'get'
  })
}

// 产线分析列表
export function getList(data) {
  return axios({
    url: '/api/banner/mass/line',
    method: 'post',
    data
  })
}

// 产线分析总数
export function getListTotal(data) {
  return axios({
    url: '/api/banner/mass/line/total',
    method: 'post',
    data
  })
}
